import React from "react";
import { PageShell } from "../components/Layout";
import { CONTACT } from "../mock";
import { Mail, Phone, Clock, Send, CircleDot } from "lucide-react";
import useSeo from "../hooks/useSeo";

export default function Counter() {
  useSeo({
    title: "Sunday Ground Teer Counter | Contact & Support",
    description:
      "Contact the Sunday Ground Teer counter for results, common number and any query. Email us at Shillongmorningteer4758@gmail.com. Result time F/R 4:30 PM, S/R 5:30 PM.",
  });
  return (
    <PageShell title="Counter" subtitle="Get in touch with Sunday Ground Teer">
      <div className="max-w-lg mx-auto">
        <div className="bg-gradient-to-b from-white to-[#fbf6ee] rounded-2xl shadow-sm border border-gray-200 p-7 text-center">
          <div className="w-16 h-16 rounded-full bg-[#e8491d] flex items-center justify-center mx-auto mb-4 shadow">
            <CircleDot className="w-9 h-9 text-white" />
          </div>
          <h2 className="text-xl font-black text-[#1f2733] mb-1">Contact Counter</h2>
          <p className="text-sm text-gray-500 mb-6">
            For results, common number & any query, reach us on email.
          </p>

          <a
            href={`mailto:${CONTACT.email}`}
            className="flex items-center gap-3 justify-center bg-white border border-gray-200 rounded-xl px-4 py-3.5 hover:border-[#e8491d] transition-colors mb-3"
          >
            <Mail className="w-5 h-5 text-[#e8491d] shrink-0" />
            <span className="font-bold text-[#1f2733] text-sm break-all">{CONTACT.email}</span>
          </a>

          <div className="flex items-center gap-3 justify-center bg-white border border-gray-200 rounded-xl px-4 py-3.5">
            <Clock className="w-5 h-5 text-[#1aa79a] shrink-0" />
            <span className="font-semibold text-gray-600 text-sm">
              Result Time: F/R 4:30 PM • S/R 5:30 PM
            </span>
          </div>

          <a
            href={`mailto:${CONTACT.email}`}
            className="mt-6 inline-flex items-center gap-2 bg-[#e8491d] text-white font-bold px-6 py-3 rounded-xl hover:bg-[#c53a12] transition-colors"
          >
            <Send className="w-4 h-4" /> Send Email
          </a>
        </div>
      </div>
    </PageShell>
  );
}
